import { render } from "./personalData.vue?vue&type=template&id=82796312&ts=true"
import script from "./personalData.vue?vue&type=script&lang=ts"
export * from "./personalData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__